import React from "react";
import SVG from "react-inlinesvg";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

export const ReusableMenuLink = ({
  onClick,
  srcImage,
  headingText,
  styleClass,
}) => {
  return (
    <React.Fragment>
      <div
        aria-controls="example-collapse-text"
        className={`drop_down_menu_collapse cursor ${styleClass}`}
      >
        <div className="d-flex" onClick={onClick}>
          <SVG
            src={srcImage}
            alt="Menu Icon"
            title={headingText}
            className="empty-div"
          />
          <h3>{headingText}</h3>
        </div>
      </div>
    </React.Fragment>
  );
};

export const ReusableMenuLinkCollapse = ({
  onClick,
  state,
  srcImage,
  headingText,
  styleClass,
}) => {
  return (
    <React.Fragment>
      <div
        onClick={onClick}
        aria-controls="example-collapse-text"
        aria-expanded={state}
        className={
          state === true
            ? `drop_down_menu_collapse cursor drop_down_menu_collapse_active ${styleClass}`
            : `drop_down_menu_collapse cursor`
        }
      >
        <div className="d-flex ">
          <SVG src={srcImage} alt="Menu Icon" className="empty-div" />
          <h3>{headingText}</h3>
        </div>
        {state ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </div>
    </React.Fragment>
  );
};
